export const initialState = {
  expandedRowMapById: {}, // tracks position (idx + 1) example: { '99': 2 } maps to id:99, idx:1
};

export default initialState;
